import { useEffect, useState } from 'react';
import posthog from 'posthog-js';

const LOCALHOST_OVERRIDES = {
  'pro-plan': true,
};

const isLocalhost =
  window && window.location && window.location.hostname === 'localhost';

export function usePostHogFeatureFlag(flagKey, defaultValue = false) {
  const localhostValue =
    isLocalhost && flagKey in LOCALHOST_OVERRIDES
      ? LOCALHOST_OVERRIDES[flagKey]
      : undefined;

  const [enabled, setEnabled] = useState(localhostValue ?? defaultValue);

  useEffect(() => {
    if (localhostValue !== undefined) return;

    const update = () => {
      const v = posthog.isFeatureEnabled(flagKey);
      setEnabled(typeof v === 'boolean' ? v : defaultValue);
    };
    update();
    const unsubscribe = posthog.onFeatureFlags(update);
    return () => unsubscribe?.();
  }, [flagKey, defaultValue, localhostValue]);

  return localhostValue ?? enabled;
}
